import { RootScopeEvents } from '../../common/services/root-scope-types';
import * as call from '../../modules/call';
import * as devices from '../../modules/devices';
import * as localMedia from '../../modules/local-media';
/* @ngInject */
export default class CallFramesController {
    constructor(VideoProviderFactory, pn, globalUi, $state, activeStreamService, $ngRedux, $rootScope, Browser) {
        this.VideoProviderFactory = VideoProviderFactory;
        this.pn = pn;
        this.globalUi = globalUi;
        this.$state = $state;
        this.activeStreamService = activeStreamService;
        this.$ngRedux = $ngRedux;
        this.$rootScope = $rootScope;
        this.Browser = Browser;
        this.patientModalOpen = false;
        this.unsubscribeFromStore = this.$ngRedux.connect((state) => ({
            hasMediaAccess: devices.selectors.selectMediaAccessability(state),
            hasVideo: localMedia.selectors.hasVideo(state),
            hasAudio: localMedia.selectors.hasAudio(state),
            isSelfPreviewVisible: call.selectors.isSelfPreviewVisible(state),
            isPreviewsListVisible: call.selectors.selectPreviewsListVisibility(state),
        }))(this);
    }
    get isVisible() {
        return (this.isPatient ||
            this.VideoProviderFactory.activeProvider.isInCall ||
            this.$state.includes('account.dashboard'));
    }
    get isPreviewDisplayed() {
        const isInCall = this.VideoProviderFactory.activeProvider.isInCall;
        const isMobile = this.Browser.isMobile || this.Browser.isMobileWindowWidth;
        return this.isSelfPreviewVisible || (isMobile && isInCall);
    }
    get isInGroupCall() {
        return (this.VideoProviderFactory.activeProvider.streams.length > 1 ||
            this.globalUi.ui.screenSharing);
    }
    get isMinimizedPreviewVisible() {
        return (!this.patientModalOpen &&
            this.hasMediaAccess &&
            this.isPreviewsListVisible);
    }
    onSelect(streamId) {
        if (this.isGalleryView) {
            return;
        }
        this.$rootScope.$emit(this.globalUi.ui.pinnedStreamId === streamId
            ? RootScopeEvents.USER_ACTIONS.UNPIN
            : RootScopeEvents.USER_ACTIONS.PIN);
        this.activeStreamService.pin(streamId);
    }
    getParticipantClassName(streamId) {
        let classes = 'call-frames__wrapper call-frames__wrapper-participant';
        if (this.activeStreamService.shouldAddWrapperHidden(streamId)) {
            classes += ' call-frames__wrapper--hidden';
        }
        if (this.isGalleryView) {
            classes += ' call-frames__wrapper-gallery';
        }
        if (this.globalUi.ui.isShowingWhiteboard && this.isPatient) {
            classes += ' call-frames__wrapper--mobile-whiteboard-hidden';
        }
        return classes;
    }
    /**
     * Depending on the number of streams, we use different sizes for participants miniatures:
     * For 1-1 calls we use a large miniature.
     * If the number of participants is from 2 to PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES inclusive - miniatures of medium size.
     * If the number of participants is more than PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES - small miniatures.
     * This method adds CSS class modifier to element for managing nested elements.
     *
     * Note: CSS modifier uses both for standard and gallery view.
     * Note: Screen sharing stream is counted as an additional participant.
     */
    getThumbsSizeModifier(elementClassName) {
        let streamsCount = this.VideoProviderFactory.activeProvider.streams.length;
        let modifier = null;
        if (this.globalUi.ui.screenSharing ||
            this.globalUi.ui.isShowingWhiteboard) {
            streamsCount += 1;
        }
        const isMobile = this.Browser.isMobile || this.Browser.isMobileWindowWidth;
        if (isMobile && streamsCount >= 1) {
            return `${elementClassName}--small-thumbs`;
        }
        switch (true) {
            case streamsCount === 1 &&
                !this.globalUi.ui.screenSharing &&
                !this.globalUi.ui.isShowingWhiteboard:
                modifier = 'large-thumbs';
                break;
            case streamsCount > 1 &&
                streamsCount <= call.constants.PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES:
                modifier = 'medium-thumbs';
                break;
            case streamsCount >
                call.constants.PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES:
                modifier = 'small-thumbs';
                break;
            default:
                break;
        }
        return modifier ? `${elementClassName}--${modifier}` : '';
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
